// extracted by mini-css-extract-plugin
export default {"list":"contacts_list__HxOzi","item":"contacts_item__srQxA","name":"contacts_name__++x2l","phone":"contacts_phone__Bn-qW","btn":"contacts_btn__lcdbQ"};